import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import { routes, Genralroutes } from "./routes";
import LogoWhite from "../src/assest/LogoWhite.png";
import "./App.css";
import InsuranceDetails from "./pages/POSP/Products/MotorInsurance/components/pdf";
import RenewBuyPDF from "./pages/POSP/Products/MotorInsurance/components/pdf/renewby";
import useStore from "./generalstore";
import { useAuth } from "./context/AuthContext";
import CircleLoading from "./components/Loading/CircleLoading";
import { useLoading } from "./context/loadingcontext";
import { getItemWithExpiry } from "./services/tokenExpries";
function App() {
  const [controller, dispatch] = useMaterialUIController();
  const process = useStore((state) => state.process);

  const setProcess = useStore((state) => state.setProcess);
  const pathName = window?.location?.pathname;

  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { authenticated, setAuthenticated } = useAuth();
  const { circleLoading, setCirleLoading } = useLoading();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);

      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const token = getItemWithExpiry("auth_token");

      if (!token) {
        setAuthenticated(false);
        localStorage.removeItem("authenticated");
        localStorage.removeItem("auth_token");
        navigate("/sign-in");
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;

    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

 

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {layout === "dashboard"  && pathName != "/authentication"  && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={LogoWhite}
              brandName="Keelis"
              routes={ Genralroutes }
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
          </>
        )}

        {circleLoading && <CircleLoading />}

        <Routes>
          {getRoutes( Genralroutes )}
          <Route
            path="*"
            element={
              <Navigate to={authenticated ? "/dashboard" : "/authentication"} />
            }
          />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
